import { render, staticRenderFns } from "./QuadroComplementoIcms.vue?vue&type=template&id=58c612b0&scoped=true&"
import script from "./QuadroComplementoIcms.vue?vue&type=script&lang=js&"
export * from "./QuadroComplementoIcms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c612b0",
  null
  
)

export default component.exports